"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUISettingRule = useUISettingRule;
var _SettingsContext = require("../../SettingsContext");
var _react = require("react");
var _PageIdContext = require("../PageIdContext");
var _useUISettingField = require("./useUISettingField");
function useUISettingRule(fieldId, ruleName) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    allowEmpty: false
  };
  var pageId = (0, _PageIdContext.usePageId)();
  var field = (0, _useUISettingField.useUISettingField)(fieldId);
  var rules = (0, _react.useMemo)(function () {
    return field.rules && field.rules.find(function (r) {
      return typeof r[ruleName] !== 'undefined';
    });
  }, [field.rules, ruleName]);
  if (!rules) {
    if (!options.allowEmpty) {
      throw new _SettingsContext.UISettingsError("There is no rule ".concat(ruleName, " for field ").concat(fieldId, " specified in the ").concat(pageId, " page in the UI settings"));
    }
    return undefined;
  }
  return rules[ruleName];
}